import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./SettingsServiceSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import SettingsServiceFormStepOne from "./SettingsServiceSteps/SettingsServiceFormStepOne";
import SettingsServiceFormStepTwo from "./SettingsServiceSteps/SettingsServiceFormStepTwo";

const SettingsServiceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues(props.initialValues);
    }
  }, [update, props.initialValues]);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
    >
      {({ handleSubmit }) => (
        <form
          id={props.formName}
          onSubmit={handleSubmit}
          className="SettingsServiceForm"
        >
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={step}
            onChangeIndex={(index) => setStep(index)}
          >
            <SettingsServiceFormStepOne initialValues={initialValues} />
            <SettingsServiceFormStepTwo />
          </SwipeableViews>
        </form>
      )}
    </Form>
  );
};

export default SettingsServiceForm;
